import { render } from "./flex.vue?vue&type=template&id=0125c3f8"
import script from "./flex.vue?vue&type=script&lang=js"
export * from "./flex.vue?vue&type=script&lang=js"

import "./flex.vue?vue&type=style&index=0&id=0125c3f8&lang=scss"

import exportComponent from "/Users/kariyaryoma/python/sg-post/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__